// Fiche appareil : sites web surveillés rattachés à ce serveur. N'affiche rien
// s'il n'y en a aucun — la plupart des machines n'hébergent pas de site.

import { useEffect, useState } from 'react';
import { Globe } from 'lucide-react';
import { api } from '../lib/api.jsx';
import { fmtRelativeFromNow } from '../lib/format.jsx';
import { monitorState, StatusDot, fmtPct, pctTone } from '../lib/webmonitor.jsx';

export function HostedSitesPanel({ agentId, sectionCls, sTitleCls }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    let alive = true;
    const load = () =>
      api.get('/platform/web-monitors?agentId=' + agentId).then((r) => alive && setRows(r || []));
    load();
    const iv = setInterval(load, 60000);
    return () => {
      alive = false;
      clearInterval(iv);
    };
  }, [agentId]);
  if (rows.length === 0) return null;
  return (
    <div className={sectionCls}>
      <div className={sTitleCls}>
        <Globe size={15} strokeWidth={1.75} /> Sites web hébergés
      </div>
      <div className="flex flex-col gap-1.5">
        {rows.map((m) => {
          const s = monitorState(m);
          return (
            <a
              key={m.id}
              href={'#/websites/' + m.id}
              className="flex items-center gap-2.5 text-[12px] rounded-lg px-2 py-1.5 -mx-2 hover:bg-card-hi no-underline"
            >
              <StatusDot m={m} size="w-2 h-2" />
              <span className="text-fg-2 font-semibold truncate flex-1 min-w-0" title={m.url}>
                {m.name}
              </span>
              <span className={`text-[11px] ${s.tone} whitespace-nowrap`}>
                {s.label}
                {s.since && ' · ' + fmtRelativeFromNow(s.since)}
              </span>
              <span className={`font-mono text-[11px] w-[62px] text-right ${pctTone(m.uptime30d)}`} title="Disponibilité sur 30 jours">
                {fmtPct(m.uptime30d)}
              </span>
            </a>
          );
        })}
      </div>
    </div>
  );
}
